export class Classbook {
    constructor(
      public id: string,
      public comment: any,
      public group: any,
      public parents: any[],
      public sendDate: Date,
      public student: any,
      public teacher: any,
      public approve: any,
      public isApproved: boolean,
    ) { }
  }



// WEBPACK FOOTER //
// ./src/app/classbook/shared/classbook.model.ts